import { createPermission } from '@backstage/plugin-permission-common';

export const infrawalletViewPermission = createPermission({
  name: 'infrawallet.view',
  attributes: { action: 'read' },
});

export const infrawalletPermissions = [infrawalletViewPermission];